import { render, staticRenderFns } from "./CatalogOffer.vue?vue&type=template&id=08123326&scoped=true"
import script from "./CatalogOffer.vue?vue&type=script&lang=js"
export * from "./CatalogOffer.vue?vue&type=script&lang=js"
import style0 from "./CatalogOffer.vue?vue&type=style&index=0&id=08123326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08123326",
  null
  
)

export default component.exports